import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import GroupIcon from '@mui/icons-material/Group'
import ScheduleIcon from '@mui/icons-material/Schedule'
import classNames from 'classnames'
import { gql } from 'graphql-tag'
import get from 'lodash/get'
import { inject } from 'mobx-react'
import React from 'react'
import { Query } from 'react-apollo'
import RestrictedView from '../auth/RestrictedView'
import { getMomentFromTime } from '../cookingPlan/helpers'
import { i18n } from '../index'
import css from './customerTargetBar.css'
const CUSTOMER_TARGET_BAR_QUERY = gql`
  query CustomerTargetBarQuery($stationId: ID!, $date: String!) {
    calculatedBuffetTargets(stationId: $stationId, date: $date) {
      __typename
      startTime
      endTime
      target
      date
      station {
        id
      }
    }
    customerTargets(stationId: $stationId, fromDate: $date, toDate: $date, productType: Buffet) {
      __typename
      date
      station {
        id
      }
      target
      calculatedTarget
    }
  }
`
type Props = {
  title: string
  showCheckButton?: boolean
  className?: string
  stationStore: any
  date: string
  isChecked: boolean
  onCheckedChange: (...args: Array<any>) => any
}

@inject('stationStore')
class CustomerTargetBar extends React.Component<Props> {
  onCheckedClick = () => {
    this.props.onCheckedChange(!this.props.isChecked)
  }

  render() {
    const { title, showCheckButton, className, date, stationStore, isChecked } = this.props
    const stationId = stationStore.getActiveStationId()
    return (
      <Query
        query={CUSTOMER_TARGET_BAR_QUERY}
        variables={{
          date,
          stationId,
        }}
        fetchPolicy='network-only'
      >
        {({ data, loading }) => {
          const slots: { target: number; startTime: string; endTime: string }[] = get(
            data,
            'calculatedBuffetTargets',
            [],
          )
          const customerTargets: { target: number; calculatedTarget: number }[] = get(data, 'customerTargets', [])
          const customerTarget = customerTargets.length ? customerTargets[0] : null
          const calculatedTotal = slots.reduce((prev, cur) => {
            return prev + cur.target
          }, 0)

          if (loading) {
            return null as unknown as JSX.Element
          }

          if (
            !loading &&
            (!customerTarget || (!Number(customerTarget.target) && !Number(customerTarget.calculatedTarget)))
          ) {
            return (
              <div className={classNames(css.component, className)}>
                <p className={css.title}>{title}</p>
                <p className={css.emptyText}>{i18n.t('customerTargetBar.emptyText')}</p>
              </div>
            )
          }

          return (
            <div className={classNames(css.component, className)}>
              <p className={css.title}>{title}</p>
              <div className={css.table}>
                <div className={css.icons}>
                  <GroupIcon className={css.groupIcon} />
                  <ScheduleIcon className={css.scheduleIcon} />
                </div>

                {slots.map((slot, i) => {
                  const startTime = getMomentFromTime(slot.startTime, false)
                  const endTime = getMomentFromTime(slot.endTime, false)
                  return (
                    <div className={css.timeSlot} key={i}>
                      <div className={css.timeSlotContent}>
                        <span className={css.timeSlotValue}>{slot.target}</span>
                        <span className={css.timeSlotLabel}>
                          {startTime.format('HH:mm')} - {endTime.format('HH:mm')}
                        </span>
                      </div>
                    </div>
                  )
                })}

                <div className={css.total}>
                  <span className={css.totalValue}>{calculatedTotal}</span>
                  <span className={css.totalText}>{i18n.t('cookingPlan.customerTargetTotal')}</span>
                </div>
                <RestrictedView requiredPermission='edit_cookingPlan'>
                  {!!showCheckButton && (
                    <div className={css.checked}>
                      <a onClick={this.onCheckedClick}>
                        <CheckCircleIcon
                          className={classNames(css.checkedIcon, {
                            [css.checkedIconChecked]: isChecked,
                          })}
                        />
                        <span className={css.checkedText}>{i18n.t('cookingPlan.customerTargetCheckedText')}</span>
                      </a>
                    </div>
                  )}
                </RestrictedView>
              </div>
            </div>
          )
        }}
      </Query>
    )
  }
}

export default CustomerTargetBar
